export default __webpack_public_path__ + "static/media/Group 432.824fec6e.png";